export function getYoutubeThumbnail(videoId) {
    if (videoId === '' || videoId === undefined) {
            return '';
    }
    return 'https://img.youtube.com/vi/' + videoId + '/1.jpg';
}

